const { createGlobalStyle } = require('styled-components');

export const GlobalStyle = createGlobalStyle`
`;
